"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx6 = _interopRequireDefault(require("clsx"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _commonCta = require("@mmc/common-cta");
var _commonRichText = require("@mmc/common-rich-text");
var _text = require("@mmc/text");
var _fiftyFifty = require("./fifty-fifty.propTypes");
var _fiftyFifty2 = _interopRequireDefault(require("../styles/fifty-fifty.css"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var _DataUtils = new _mmcDataUtilities["default"](),
  handleNestedProp = _DataUtils.handleNestedProp;

/**
 * ## HalfText - component
 *
 * This sub-component of Fiftyfifty component is to display formatted text block.
 */

var publishContactDealerToDataLayer = function publishContactDealerToDataLayer(cta, market) {
  var linkUrl = cta.URL;
  if ((market.toLowerCase() === 'es' || market.toLowerCase() === 'pt' || market.toLowerCase() === 'fi') && typeof window !== 'undefined' && window.dataLayer) {
    if (['/concesionarios', '/localizador-concessionarios', '/loyda-lahin-jalleenmyyjasi'].includes(linkUrl)) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'dealer_locator_click',
        comp_page: {
          position: 'page'
        }
      });
    }
    if (['/prueba', '/test-drive', '/varaa-koeajo'].includes(linkUrl)) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'test_drive_request_click',
        comp_product: {
          position: 'page',
          vehicle_type: 'car',
          brand: 'mitsubishi',
          product_condition: 'new',
          model: null,
          version: null,
          fuel_type: null,
          dealer_name: null
        }
      });
    }
  }
};
var HalfText = function HalfText(_ref) {
  var _clsx, _clsx2, _clsx3, _clsx4, _clsx5;
  var data = _ref.data,
    theme = _ref.theme,
    disclaimerData = _ref.disclaimerData,
    market = _ref.market,
    hasText = _ref.hasText;
  var cta = handleNestedProp(data, 'data.cta');
  var shouldRenderCta = (0, _react.useMemo)(function () {
    return !!cta.URL;
  }, [cta]);
  var isDarkTheme = data.theme === 'dark';
  var _ref2 = data || {},
    ctaObj = _ref2.cta,
    heading1 = _ref2.heading1,
    heading2 = _ref2.heading2,
    textBlock = _ref2.textBlock;
  var hasOnlyCta = function hasOnlyCta() {
    return !hasText && !heading2 && !!(ctaObj != null && ctaObj.label);
  };
  var hasOnlyLabel = function hasOnlyLabel() {
    return !hasText && !heading2 && !!heading1;
  };
  var getIsJustifyCenter = function getIsJustifyCenter() {
    var hasOnlyHeading = !hasText && !!heading2;
    var hasOnlyBodyText = hasText && !heading2;
    return !!(hasOnlyHeading || hasOnlyBodyText || hasOnlyCta() || hasOnlyLabel());
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx6["default"])(_fiftyFifty2["default"].textBlockWrap, (_clsx = {}, _clsx[theme.dark] = isDarkTheme, _clsx[_fiftyFifty2["default"].justifyFlexEnd_desktop] = data.carAlignment === 'right' && !getIsJustifyCenter(), _clsx[_fiftyFifty2["default"].justifyCenter] = getIsJustifyCenter(), _clsx))
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx6["default"])((_clsx2 = {}, _clsx2[_fiftyFifty2["default"].smallTextBlock] = data.size === 'small', _clsx2[_fiftyFifty2["default"].notSmallTextBlock] = data.size !== 'small', _clsx2))
  }, /*#__PURE__*/_react["default"].createElement(_text.Text, {
    text: heading1,
    className: (0, _clsx6["default"])(_fiftyFifty2["default"].marginBottom16, theme.labelMedium, (_clsx3 = {}, _clsx3[_fiftyFifty2["default"].whiteButtons] = isDarkTheme, _clsx3), _fiftyFifty2["default"].heading),
    tag: "h2",
    disclaimerData: disclaimerData
  }), /*#__PURE__*/_react["default"].createElement(_text.Text, {
    className: (0, _clsx6["default"])(theme.headingTwo, _fiftyFifty2["default"].heading2, (_clsx4 = {}, _clsx4[_fiftyFifty2["default"].whiteButtons] = isDarkTheme, _clsx4)),
    text: heading2,
    tag: data.headingTag || 'h3',
    disclaimerData: disclaimerData
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx6["default"])(theme.bodyCopy, (_clsx5 = {}, _clsx5[_fiftyFifty2["default"].whiteButtons] = isDarkTheme, _clsx5[_fiftyFifty2["default"].marginBottom24] = shouldRenderCta, _clsx5), _fiftyFifty2["default"].heading)
  }, /*#__PURE__*/_react["default"].createElement(_text.Text, {
    text: /*#__PURE__*/_react["default"].createElement(_commonRichText.CommonRichText, {
      theme: theme,
      format: null,
      html: textBlock,
      tagName: "p"
    }),
    disclaimerData: disclaimerData
  })), shouldRenderCta && /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
    className: _fiftyFifty2["default"].halfTextCta,
    data: cta,
    "data-section": heading2,
    theme: theme,
    mouseDownEvent: function mouseDownEvent() {
      return publishContactDealerToDataLayer(cta, market);
    }
  })));
};
HalfText.displayName = 'HalfText';
var _default = HalfText;
exports["default"] = _default;